export const PaymentImages = {
    stripe: ['/stripe-dark.png', '/mastercard.png', '/visa.png', '/american-express.png'],
    paypal: ['/paypal.png', '/mastercard.png', '/visa.png'],
    paygate_payweb: ['/paygate.png', '/mastercard.png', '/visa.png'],
    cardconnect: ['/mastercard.png', '/visa.png', '/american-express.png'],
    bambora_apac: ['/mastercard.png', '/visa.png'],
    poli_pay: ['/poli.png'],
    swish: ['/swish.png'],
    fiserv: ['/fiserv.png'],
    viva_wallet: ['/viva-wallet.png'],
    paymongo: ['/paymongo.svg', '/bpi.png', '/gcash.png', '/grabpay.png', '/maya.png'],
};
//# sourceMappingURL=payment_images.js.map